module.exports = __webpack_public_path__ + "static/hero-header-illustration-m-d72e6bc9faed71e35cceec7e6b0bd00b.svg";